import React from "react";

const YesNo = ({style = {}, size = "36", className = "", fill = "#73788B", stroke = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle className="u_stroke" cx={18} cy={18} r={14} stroke={stroke} strokeWidth={4}/>
        <circle className="u_fill" cx={18} cy={18} r={6.857} fill={fill}/>
    </svg>
);

export default YesNo;
